export interface InvertedCIconProps {
  fill: string;
}
function InvertedCIcon({ fill }: InvertedCIconProps) {
  return (
    <svg viewBox="0 0 312 387" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M118.374 0C73.7977 0 32.7355 15.0544 0 40.3647L65.2115 118.563C80.2192 107.912 98.5648 101.646 118.374 101.646C169.139 101.646 210.295 142.773 210.295 193.503C210.295 244.232 169.139 285.354 118.374 285.354C98.6583 285.354 80.3854 279.15 65.4192 268.583L0.197267 346.791C32.8913 372.008 73.8808 387 118.369 387C225.313 387 312 300.362 312 193.503C312.005 86.6329 225.318 0 118.374 0Z"
        fill={fill}
      />
    </svg>
  );
}

export default InvertedCIcon;
